import {
  PaddedDiv,
  SectionWrapper,
} from 'modules/Exp-Candidates/Components/Styles/style'
import DrivePage from 'modules/Exp-Candidates/DrivePage/index'
import React from 'react'

const ExpCandidateDrives = ({
  listOfDrivesDetails,
  getExpDriveListData,
  requestToChange,
  confirmDrive,
  recreateCall,
  setDashboardNavs,
  dashboardNavs,
}) => {
  return (
    <SectionWrapper column>
      <PaddedDiv column>
        <DrivePage
          listOfDrivesDetails={listOfDrivesDetails || []}
          getExpDriveListData={getExpDriveListData}
          requestToChange={requestToChange}
          confirmDrive={confirmDrive}
          setDashboardNavs={setDashboardNavs}
          dashboardNavs={dashboardNavs}
          recreateCall={recreateCall}
        />
      </PaddedDiv>
    </SectionWrapper>
  )
}

export default ExpCandidateDrives
